module.exports = __webpack_public_path__ + "src/assets/img/cmdOpenTrunk.560eee07.svg";